module.exports = __webpack_public_path__ + "static/SectionOne-79f7256ef926256a0c4492c3e02ba3bb.png";